/**
 * @generated SignedSource<<d09ebc21f173df47725dd30edd07bb77>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notes",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountRelationUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateAccountRelationTPayload",
        "kind": "LinkedField",
        "name": "updateAccountRelationTByAccountRelationId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountRelationT",
            "kind": "LinkedField",
            "name": "accountRelationT",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AccountRelationUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateAccountRelationTPayload",
        "kind": "LinkedField",
        "name": "updateAccountRelationTByAccountRelationId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountRelationT",
            "kind": "LinkedField",
            "name": "accountRelationT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2593c4492538c5a89663b089a10dd194",
    "id": null,
    "metadata": {},
    "name": "AccountRelationUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation AccountRelationUpdateMutation(\n  $input: UpdateAccountRelationTByAccountRelationIdInput!\n) {\n  updateAccountRelationTByAccountRelationId(input: $input) {\n    accountRelationT {\n      notes\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "f3224207ffdf0abb19da905099193c38";

module.exports = node;
